var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.sendconfigList.length>0)?_c('div',{staticClass:"adlist-bar"},[_c('div',{staticClass:"adlist-text"},[_vm._v(" "+_vm._s(_vm.adlistItem.copywriting)+" ")]),_c('div',{staticClass:"adlist-link"},[_c('router-link',{attrs:{"to":{ path: _vm.adlistItem.url }}},[_vm._v(" "+_vm._s(_vm.adlistItem.button_text)+" ")])],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }